import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AppFooter() {
  const { t, i18n } = useTranslation();
  const year = new Date().getFullYear();
  const es = i18n.language?.startsWith("es");

  return (
    <footer
      data-testid="app-footer"
      className="border-t border-slate-200 bg-white mt-10 px-6 py-5 text-xs text-slate-600"
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="font-mono">
          IQES LLC © {year} · <span className="text-slate-500">IQ-APP v1.1.0</span>
        </div>
        <nav className="flex flex-wrap gap-4">
          <Link to="/references" className="hover:text-[#003366] transition-colors" data-testid="footer-references">
            {es ? "Referencias técnicas" : "Technical references"}
          </Link>
          <Link to="/legal/privacy" className="hover:text-[#003366] transition-colors" data-testid="footer-privacy">
            {es ? "Política de privacidad" : "Privacy policy"}
          </Link>
          <Link to="/legal/terms" className="hover:text-[#003366] transition-colors" data-testid="footer-terms">
            {es ? "Términos de uso" : "Terms of use"}
          </Link>
          <Link to="/legal/compliance" className="hover:text-[#003366] transition-colors" data-testid="footer-compliance">
            {es ? "Cumplimiento" : "Compliance"}
          </Link>
        </nav>
      </div>
      <div className="mt-3 text-[11px] text-slate-500 leading-relaxed max-w-4xl">
        {es
          ? "IQ-APP genera estimaciones y documentación referenciales con asistencia de IA. Los reportes deben ser revisados por un Ingeniero Profesional (PE) licenciado antes de uso en construcción. NEC®, NFPA®, TIA®, BICSI® y todas las marcas asociadas pertenecen a sus respectivos titulares."
          : "IQ-APP produces referential estimates and documentation with AI assistance. Reports must be reviewed by a licensed Professional Engineer (PE) before construction use. NEC®, NFPA®, TIA®, BICSI®, and all associated marks belong to their respective holders."}
      </div>
    </footer>
  );
}
